export default __webpack_public_path__ + "static/media/compare-performance-icon.bcc6a05f.svg";